/*
 * Public API Surface of ng2-image-upload
 */

export * from './lib/image-upload.module';
export * from './lib/image-upload/image-upload.component';
export * from './lib/style';
export * from './lib/upload-metadata';
export * from './lib/file-holder';
